import Stack from 'components/commons/stack';
import { Skeleton } from 'components/widgets/skeleton';
import staticFilePaths from 'constant/static-file';
import { styles } from 'modules/home/style';

export default function SkeletonTermAndCondition() {
  return (
    <Stack alignItems="center">
      <Stack.Item
        alignItems="center"
        css={{
          width: '100%',
          padding: 128,
          background: 'rgba(16, 79, 166, 0.3)',
          backgroundImage: `url("${staticFilePaths.termAndConditionBgWEBP}")`,
          backgroundBlendMode: 'multiply',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          position: 'relative',
        }}
      >
        <Skeleton css={{ height: 50, width: 300, borderRadius: 8 }} />
      </Stack.Item>
      <Stack.Item
        css={{
          ...styles.breakPointsCss,
          margin: '40px auto',
        }}
      >
        <Skeleton
          css={{ position: 'relative', inset: 0, height: 300, borderRadius: 8 }}
        />
      </Stack.Item>
    </Stack>
  );
}
